module.exports = __webpack_public_path__ + "img/vertical_3_4_6000.8e14735e.png";